module.exports = __webpack_public_path__ + "static/media/instructivoac5.8ddf4d0a.png";